/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * One field that stops the shipment being bookable
 * @export
 * @interface BookingFieldViolation
 */
export interface BookingFieldViolation {
    /**
     * Stable key the dashboard maps to its own input (e.g. deliveryContact.phoneNumber, deliveryDeadline)
     * @type {string}
     * @memberof BookingFieldViolation
     */
    field: string;
    /**
     * What a person reads
     * @type {string}
     * @memberof BookingFieldViolation
     */
    message: string;
}

/**
 * Check if a given object implements the BookingFieldViolation interface.
 */
export function instanceOfBookingFieldViolation(value: object): value is BookingFieldViolation {
    if (!('field' in value) || value['field'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function BookingFieldViolationFromJSON(json: any): BookingFieldViolation {
    return BookingFieldViolationFromJSONTyped(json, false);
}

export function BookingFieldViolationFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookingFieldViolation {
    if (json == null) {
        return json;
    }
    return {
        
        'field': json['field'],
        'message': json['message'],
    };
}

  export function BookingFieldViolationToJSON(json: any): BookingFieldViolation {
      return BookingFieldViolationToJSONTyped(json, false);
  }

  export function BookingFieldViolationToJSONTyped(value?: BookingFieldViolation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'field': value['field'],
        'message': value['message'],
    };
}

